var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPincode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4286 10.5714C11.2012 10.5714 10.9832 10.6617 10.8225 10.8225C10.6617 10.9832 10.5714 11.2012 10.5714 11.4286V17.4286C10.5714 17.7442 10.3156 18 10 18C9.68441 18 9.42857 17.7442 9.42857 17.4286V11.4286C9.42857 10.8981 9.63929 10.3894 10.0144 10.0144C10.3894 9.63929 10.8981 9.42857 11.4286 9.42857C11.959 9.42857 12.4677 9.63929 12.8428 10.0144C13.2179 10.3894 13.4286 10.8981 13.4286 11.4286V14H15.1429C15.9006 14 16.6273 14.301 17.1632 14.8368C17.699 15.3727 18 16.0994 18 16.8571V17.4286C18 17.7442 17.7442 18 17.4286 18C17.113 18 16.8571 17.7442 16.8571 17.4286V16.8571C16.8571 16.4025 16.6765 15.9665 16.355 15.645C16.0335 15.3235 15.5975 15.1429 15.1429 15.1429H12.8571C12.5416 15.1429 12.2857 14.887 12.2857 14.5714V11.4286C12.2857 11.2012 12.1954 10.9832 12.0347 10.8225C11.8739 10.6617 11.6559 10.5714 11.4286 10.5714Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.14286C2 2.51167 2.51167 2 3.14286 2C3.77404 2 4.28571 2.51167 4.28571 3.14286C4.28571 3.77404 3.77404 4.28571 3.14286 4.28571C2.51167 4.28571 2 3.77404 2 3.14286Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57143 3.14286C6.57143 2.51167 7.0831 2 7.71429 2C8.34547 2 8.85714 2.51167 8.85714 3.14286C8.85714 3.77404 8.34547 4.28571 7.71429 4.28571C7.0831 4.28571 6.57143 3.77404 6.57143 3.14286Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1429 3.14286C11.1429 2.51167 11.6545 2 12.2857 2C12.9169 2 13.4286 2.51167 13.4286 3.14286C13.4286 3.77404 12.9169 4.28571 12.2857 4.28571C11.6545 4.28571 11.1429 3.77404 11.1429 3.14286Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.14286C2 6.51168 2.51167 6 3.14286 6C3.77404 6 4.28571 6.51168 4.28571 7.14286C4.28571 7.77404 3.77404 8.28572 3.14286 8.28572C2.51167 8.28572 2 7.77404 2 7.14286Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57143 7.14286C6.57143 6.51168 7.0831 6 7.71429 6C8.34547 6 8.85714 6.51168 8.85714 7.14286C8.85714 7.77404 8.34547 8.28572 7.71429 8.28572C7.0831 8.28572 6.57143 7.77404 6.57143 7.14286Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1429 7.14286C11.1429 6.51168 11.6545 6 12.2857 6C12.9169 6 13.4286 6.51168 13.4286 7.14286C13.4286 7.77404 12.9169 8.28572 12.2857 8.28572C11.6545 8.28572 11.1429 7.77404 11.1429 7.14286Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.1429C2 10.5117 2.51167 10 3.14286 10C3.77404 10 4.28571 10.5117 4.28571 11.1429C4.28571 11.774 3.77404 12.2857 3.14286 12.2857C2.51167 12.2857 2 11.774 2 11.1429Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90616 10.3347C7.12049 10.1204 7.41118 10 7.71429 10C8.02988 10 8.28571 10.2558 8.28571 10.5714V11.7143C8.28571 12.0299 8.02988 12.2857 7.71429 12.2857C7.41118 12.2857 7.12049 12.1653 6.90616 11.951C6.69184 11.7367 6.57143 11.446 6.57143 11.1429C6.57143 10.8398 6.69184 10.5491 6.90616 10.3347Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPincode);
export default __webpack_public_path__ + "static/media/pincode.9e7a482fac18a0773ffe085a079739e0.svg";
export { ForwardRef as ReactComponent };